// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","cardContentContainer":"Card_cardContentContainer__2pH5w","cardTitle":"Card_cardTitle__350c8","cardContent":"Card_cardContent__31-tX"};